/* 横方向の自動スクロール＆無限ループ（共通部品） */
(function () {
  "use strict";

  var roots = document.querySelectorAll(".fsj-carousel");
  if (!roots.length) return;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var RESUME_DELAY = 1200; /* 操作をやめてから自動送りを再開するまで(ms) */

  Array.prototype.forEach.call(roots, function (root) {
    var track = root.querySelector(".fsj-carousel__track");
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;

    var setWidth = originals.reduce(function (sum, li) {
      return sum + li.getBoundingClientRect().width + gap;
    }, 0);
    if (!setWidth) return;

    var sets = Math.max(3, Math.ceil((root.clientWidth * 2) / setWidth) + 1);
    for (var i = 1; i < sets; i++) {
      originals.forEach(function (li) {
        var clone = li.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        Array.prototype.forEach.call(clone.querySelectorAll("a, button"), function (el) {
          el.setAttribute("tabindex", "-1");
        });
        track.appendChild(clone);
      });
    }

    root.classList.add("is-scrollable");

    var startOffset = setWidth;
    if (root.hasAttribute("data-start-half")) {
      startOffset += originals[0].getBoundingClientRect().width / 2;
    }
    root.scrollLeft = startOffset;

    /* 端に来たら1セット分ずらして位置を戻す（見た目は変わらない） */
    function wrap() {
      if (root.scrollLeft >= setWidth * 2) root.scrollLeft -= setWidth;
      else if (root.scrollLeft < setWidth * 0.5) root.scrollLeft += setWidth;
    }

    var speed = parseFloat(track.getAttribute("data-speed")) || 60; /* px/秒 */
    var holds = 0;      /* 1以上なら自動送りを止める */
    var idleTimer = null;
    var lastTime = null;

    function hold() {
      holds++;
      if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
    }
    function release(immediate) {
      holds = Math.max(0, holds - 1);
      if (immediate) return;
      if (idleTimer) clearTimeout(idleTimer);
      /* 操作直後にすぐ動き出すと落ち着かないので少し待つ */
      holds++;
      idleTimer = setTimeout(function () { holds = Math.max(0, holds - 1); }, RESUME_DELAY);
    }

    function step(now) {
      if (lastTime === null) lastTime = now;
      var dt = (now - lastTime) / 1000;
      lastTime = now;
      /* タブが非表示から戻ったときに大きく飛ばないよう上限を設ける */
      if (dt > 0.1) dt = 0.1;
      if (!holds && !reduceMotion) {
        root.scrollLeft += speed * dt;
        wrap();
      }
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);

    /* ---- 最初の表示だけ、写真を1枚ずつ出す（data-intro が付いているとき） ---- */
    if (root.hasAttribute("data-intro") && !reduceMotion) {
      root.classList.add("is-intro");
      hold();

      var STEP = 170;   /* 1枚ずつずらす間隔(ms) */
      var FADE = 900;   /* CSS側のフェード時間と合わせる */
      var rootRect = root.getBoundingClientRect();
      var shown = 0;

      Array.prototype.forEach.call(track.children, function (li) {
        var r = li.getBoundingClientRect();
        var inView = r.right > rootRect.left + 4 && r.left < rootRect.right - 4;
        if (!inView) {
          li.classList.add("is-in");
          return;
        }
        var delay = 80 + shown * STEP;
        shown++;
        setTimeout(function () { li.classList.add("is-in"); }, delay);
      });

      /* 出し終えたら演出用のクラスを外し、自動送りを再開する */
      setTimeout(function () {
        root.classList.remove("is-intro");
        release(true);
      }, 80 + shown * STEP + FADE);
    }

    /* ---- ホバー中は止める（見たいものを読めるように） ---- */
    root.addEventListener("mouseenter", function () { hold(); });
    root.addEventListener("mouseleave", function () { release(true); });

    /* ---- 指・トラックパッドの操作中は止める（スクロール自体はブラウザ任せ） ---- */
    root.addEventListener("touchstart", function () { hold(); }, { passive: true });
    root.addEventListener("touchend", function () { release(); }, { passive: true });
    root.addEventListener("wheel", function () { hold(); release(); }, { passive: true });
    root.addEventListener("scroll", wrap, { passive: true });

    /* ---- マウスはドラッグで送れるようにする（PCには横スワイプがないため） ---- */
    var dragging = false, startX = 0, startScroll = 0, moved = 0;

    root.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      dragging = true; moved = 0;
      startX = e.clientX;
      startScroll = root.scrollLeft;
      root.setPointerCapture(e.pointerId);
      root.classList.add("is-dragging");
      hold();
    });

    root.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      root.scrollLeft = startScroll - dx;
      wrap();
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove("is-dragging");
      release();
    }
    root.addEventListener("pointerup", endDrag);
    root.addEventListener("pointercancel", endDrag);

    /* ドラッグのつもりがクリックとして扱われないようにする */
    root.addEventListener("click", function (e) {
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });
})();
